import './pollyfills'
import VueRouter from 'vue-router'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import PortalVue from 'portal-vue'
// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import GlobalMixins from './globalMixins'
import SideBar from 'src/components/SidebarPlugin'
import Notify from 'src/components/NotificationPlugin'
import AvatarGenerator from './avatarGenerator';
import DateFormatPlugin from './dateFormatPlugin';
import 'src/utils/customValidations';
import '../filters/currencyFilter';

// library imports
import 'src/assets/sass/paper-dashboard.scss'
import 'src/assets/sass/tailwind.css'

export default {
  install(Vue) {
    // plugin setup
    Vue.use(VueRouter);
    Vue.use(GlobalDirectives);
    Vue.use(GlobalComponents);
    Vue.use(GlobalMixins);
    Vue.use(AvatarGenerator);
    Vue.use(DateFormatPlugin);
    Vue.use(Notify);
    Vue.use(SideBar);
    Vue.use(PortalVue);
    Vue.use(VeeValidate, {
      events: 'change|clear|input|placechanged|inputChange',
      fieldsBagName: 'veeFields',
    });
    locale.use(lang)
  }
}
